<span class="badge bg-light text-primary">{{itemCount}}</span>
